export default __webpack_public_path__ + "static/media/beer_loga_pub.885c7926.jpg";